import InventoryFilterAdvancedFilter from "./InventoryFilterAdvancedFilter";

export default InventoryFilterAdvancedFilter;
export { InventoryFilterAdvancedFilter };
